/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import classnames from 'classnames';

import './ShareCardColorSwatch.styles.scss';

interface Props {
  selected: boolean;
  color: any;
  onClick(): void;
}
const ShareCardColorSwatch: React.FC<Props> = (props) => {
  const mainStyleClass = classnames('share-card-color-swatch', {
    'swatch-selected': props.selected,
  });

  const cssColor = `rgba(${props.color.r},${props.color.g},${props.color.b},${1})`;

  return (
    <div
      className={mainStyleClass}
      style={{
        border: props.selected ? `2px solid ${cssColor}` : '0px',
      }}
      onClick={props.onClick}
    >
      <div
        className="share-card-color-swatch-interior"
        style={{ backgroundColor: cssColor }}
      />
    </div>
  );
};

export default ShareCardColorSwatch;
